import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TextField from "../formik/TextField";
import SubmitButton from "../button/SubmitButton";

const useStyles = makeStyles(theme => ({
  paper: {
    width: "100%",
    padding: "10px"
  },
  form: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    paddingBottom: "13px",
    minWidth: "300px"
  }
}));

export default function TextSearch({ label, handleSearch, isSubmitting }) {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <Formik
        initialValues={{ searchText: "" }}
        onSubmit={values => {
          handleSearch(values.searchText);
        }}
        validationSchema={Yup.object().shape({
          searchText: Yup.string()
            .trim()
            .required("Enter text to search!")
        })}
      >
        {props => {
          const { touched, errors } = props;
          return (
            <Form className={classes.form}>
              <Field
                component={TextField}
                name="searchText"
                margin="dense"
                label={label}
                className={classes.textField}
                helperText={
                  touched.searchText && errors.searchText && errors.searchText
                }
                error={!!touched.searchText && !!errors.searchText}
                disabled={isSubmitting}
                autoFocus
              />
              <SubmitButton disabled={isSubmitting} isSubmitting={isSubmitting}>
                Search
              </SubmitButton>
            </Form>
          );
        }}
      </Formik>
    </Paper>
  );
}
